document.addEventListener('DOMContentLoaded', () => {
    const openMenuMobile = document.querySelector('.header__gapfy .open_nav_items');
    const closeMenuMobile = document.querySelector('.header__gapfy .close_nav_items');
    const floatingProduct = document.querySelector('.floating-product');

    openMenuMobile.addEventListener('click', () => {
        const navItems = document.querySelector('.header__menu_mobile .nav_items');
        navItems.setAttribute('open', '');
        document.body.style.overflow = 'hidden';
        floatingProduct.style.display = 'none';
    });

    closeMenuMobile.addEventListener('click', () => {
        const navItems = document.querySelector('.header__menu_mobile .nav_items');
        navItems.removeAttribute('open');
        document.body.style.overflow = 'auto';
        floatingProduct.style.display = 'flex';
    });

    const linksWithSubmenu = document.querySelectorAll('.nav_items [data-menu]');
    const mainLinks = document.querySelector('.nav_items .main_items');

    linksWithSubmenu.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault(); // Prevent default link behavior if it's a link
            const submenuDesktop = document.querySelector(`.header__menu_desktop .nav_items [data-submenu="${link.dataset.menu}"]`);
            const submenuMobile = document.querySelector(`.header__menu_mobile .nav_items [data-submenu="${link.dataset.menu}"]`);
            
            // Check if the clicked submenu is ALREADY open (desktop)
            const isDesktopOpen = submenuDesktop && !submenuDesktop.hasAttribute('closed');
            
            const allSubmenus = document.querySelectorAll('.nav_items [data-submenu]');

            // Close all submenus first
            allSubmenus.forEach(sub => sub.setAttribute('closed', ''));

            // If it was NOT open, open it now. If it WAS open, it stays closed (toggled off).
            if (!isDesktopOpen) {
                if (submenuDesktop) submenuDesktop.removeAttribute('closed');
                if (submenuMobile) submenuMobile.removeAttribute('closed');
                
                 // Ensure main_items is closed when a submenu is open (if that's the desired behavior)
                 // Based on original code, it seems main_items might be related to mobile view navigation?
                 // Keeping original logic:
                if (!mainLinks.hasAttribute('closed')) {
                    mainLinks.setAttribute('closed', '');
                }
            } else {
                 // If we are closing the menu, we might want to ensure main_items is visible again?
                 // The original code didn't explicitly revert mainLinks 'closed' state here, 
                 // but line 49 (back button) does. 
                 // For desktop mega menu, mainLinks usually stays visible. 
                 // Let's just focus on the submenu toggle for now.
                 if (mainLinks.hasAttribute('closed')) {
                    mainLinks.removeAttribute('closed');
                }
            }
        });
    });

    const sublinkBack = document.querySelectorAll('.nav_items .submenu_back__container');
    sublinkBack.forEach(back => {
        back.addEventListener('click', () => {
            const submenu = back.closest('[data-submenu]');
            if (submenu) {
                submenu.setAttribute('closed', '');
                mainLinks.removeAttribute('closed'); // volta a mostrar os itens principais
            }
        });
    });

    const searchIcon = document.querySelector('.header__gapfy .header__search .search__open');
    const searchClose = document.querySelector('.header__gapfy .header__search .search_input__container .search_close');

    searchIcon.addEventListener('click', () => {
        const searchInput = document.querySelector('.header__gapfy .header__search .search_input__container');
        searchInput.toggleAttribute('open');

        const otherSubmenus = document.querySelectorAll('.header__menu_desktop .nav_items [data-submenu]');
        otherSubmenus.forEach(otherSubmenu => {
            otherSubmenu.setAttribute('closed', '');
        });
    });

    searchClose.addEventListener('click', () => {
        const searchInput = document.querySelector('.header__gapfy .header__search .search_input__container');
        searchInput.toggleAttribute('open');
    });

    const header = document.querySelector('.header__section');
    let initialScroll = window.scrollY;

    window.addEventListener('scroll', () => {
        if (window.scrollY > initialScroll && window.scrollY > 100) {
            header.style.transform = 'translateY(-100%)';
            const otherSubmenus = document.querySelectorAll('.header__menu_desktop .nav_items [data-submenu]');
            otherSubmenus.forEach(otherSubmenu => {
                otherSubmenu.setAttribute('closed', '');
            });
        } else {
            header.style.transform = 'translateY(0)';
        }
        initialScroll = window.scrollY;
    });

    document.addEventListener('click', (event) => {
        const isClickInsideSubmenu = event.target.closest('.header__menu_desktop .nav_items [data-submenu]');
        const isClickOnTrigger = event.target.closest('.header__menu_desktop .nav_items [data-menu]');

        if (!isClickInsideSubmenu && !isClickOnTrigger) {
            const openSubmenus = document.querySelectorAll('.header__menu_desktop .nav_items [data-submenu]:not([closed])');
            openSubmenus.forEach(sub => sub.setAttribute('closed', ''));
            const mainLinks = document.querySelector('.header__menu_desktop .nav_items .main_items');
            if (mainLinks) mainLinks.removeAttribute('closed');
        }
    });
});
